'use strict';

(function () {
  'use strict';

  angular.module('msTracker').controller('chartDetailOverlayCtrl', chartDetailOverlayCtrl);

  chartDetailOverlayCtrl.$inject = ['$log', '$q', 'historySvc', 'start', 'end', 'trackerId', 'moodTrackerDataMappingSvc', 'close'];

  function chartDetailOverlayCtrl($log, $q, historySvc, start, end, trackerId, moodTrackerDataMappingSvc, close) {
    var vm = this;
    vm.title = 'chartDetailOverlayCtrl';
    // 200ms pause to let ngAnimate hide the modal.
    vm.closeModal = function () {
      return close(false, 200);
    };

    vm.range = moment(end).diff(moment(start), 'days');
    var startDay = moment(start);
    var endDay = moment(end).subtract(1, 'second');
    var checkinNotesAndHelpfulActivities = [historySvc.getMoodCheckins(startDay, endDay, trackerId), historySvc.getHelpfulActivities(start, end)];

    activate();

    ////////////////

    function activate() {
      $log.debug(vm.title + ' control activate');

      $q.all(checkinNotesAndHelpfulActivities).then(function (data) {
        vm.tracker = data[0];
        vm.tracker.trackerEntries = moodTrackerDataMappingSvc.mapSingleTrackerEntriesByDay(vm.tracker.trackerEntries);
        vm.activities = data[1].favoritedActivities;
        vm.inspirations = data[1].favoritedInspirations;
      });
    }
  }
})();